// extracted by mini-css-extract-plugin
export var container = "ECommerceBenefits-module--container--525c6";
export var list = "ECommerceBenefits-module--list--594a6";
export var title = "ECommerceBenefits-module--title--891ee";